var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zy-charts-bar",style:({ height: _vm.height })},[_c('div',{ref:"charts",style:({ height: _vm.height, width: _vm.width })}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }